import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash'
import { FormattedDate } from 'components/intl'
import { Table } from 'components/layout'

class SectionTable extends Component {
  static propTypes = {
    activity: PropTypes.object.isRequired
  }

  shouldComponentUpdate(nextProps) {
    return (
      get(nextProps.activity, 'id') !== get(this.props.activity, 'id') &&
      get(nextProps.activity, 'id') > 0
    )
  }

  render() {
    const { activity } = this.props
    const completedHours = `
              ${Math.floor(activity.completed / 3600)} h / ${activity.total /
      3600} h
            `

    return (
      <Table.Wrap>
        <thead>
          <Table.Row>
            <Table.Cell head intlKey="label.first_activity_started">
              First activity started
            </Table.Cell>
            <Table.Cell head intlKey="label.major">
              Major
            </Table.Cell>
            <Table.Cell head intlKey="label.hours_completed_required">
              Hours Completed/Required
            </Table.Cell>
            {/* <Table.Cell head intlKey="label.weeks_completed_required">
              Weeks Completed/Required
            </Table.Cell> */}
          </Table.Row>
        </thead>
        <tbody>
          <Table.Row>
            <Table.Cell>
              {activity.startDate
                ? <FormattedDate value={activity.startDate} />
                : '---'}
            </Table.Cell>
            <Table.Cell intlKey={activity.isMajor ? 'label.yes' : 'label.no'}>
              {activity.isMajor ? 'Yes' : 'No'}
            </Table.Cell>
            <Table.Cell>
              {completedHours}
            </Table.Cell>
            {/* <Table.Cell>???</Table.Cell> */}
          </Table.Row>
        </tbody>
      </Table.Wrap>
    )
  }
}

export default SectionTable
